import { useTabletAndBelowMediaQuery } from 'layout'
import { Pagination } from 'semantic-ui-react'

export const PaginationComponent = ({ pageChanged, totalCount, activePage, pageSize }) => {
    const isMobile = useTabletAndBelowMediaQuery()
    return (
        <Pagination
            activePage={activePage}
            onPageChange={(_, { activePage }) => pageChanged(activePage)}
            totalPages={Math.ceil(totalCount / pageSize)}
            size={isMobile ? "mini" : "large"}
            firstItem={!isMobile ? undefined : null}
            lastItem={!isMobile ? undefined : null}
        />
    )
}
